import CryptoJS from 'crypto-js';

const STORAGE_KEYS = {
	username: 'auth_username',
	password: 'auth_password',
	remember: 'auth_remember'
};

const SECRET_KEY = 'hln-remember-v1';

const getLocalItem = (key) => {
	try {
		return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
	} catch (error) {
		return null;
	}
};

const setLocalItem = (key, value) => {
	try {
		if (typeof localStorage !== 'undefined') {
			localStorage.setItem(key, value);
		}
	} catch (error) {
		// ignore
	}
};

const removeLocalItem = (key) => {
	try {
		if (typeof localStorage !== 'undefined') {
			localStorage.removeItem(key);
		}
	} catch (error) {
		// ignore
	}
};

const encryptText = (text) => {
	if (!text) {
		return '';
	}
	try {
		return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
	} catch (error) {
		return '';
	}
};

const decryptText = (cipherText) => {
	if (!cipherText) {
		return '';
	}
	try {
		return CryptoJS.AES.decrypt(cipherText, SECRET_KEY).toString(CryptoJS.enc.Utf8) || '';
	} catch (error) {
		return '';
	}
};

export const loadRemembered = () => {
	const username = getLocalItem(STORAGE_KEYS.username) || '';
	const remember = getLocalItem(STORAGE_KEYS.remember) === '1';
	let password = '';

	if (remember) {
		const cipher = getLocalItem(STORAGE_KEYS.password);
		password = decryptText(cipher);
		if (cipher && !password) {
			removeLocalItem(STORAGE_KEYS.password);
			removeLocalItem(STORAGE_KEYS.remember);
		}
	}

	return {
		username,
		password,
		remember
	};
};

export const saveRemembered = (username, password, remember) => {
	if (typeof username !== 'undefined') {
		setLocalItem(STORAGE_KEYS.username, username || '');
	}

	if (remember) {
		const encrypted = encryptText(password || '');
		if (encrypted) {
			setLocalItem(STORAGE_KEYS.password, encrypted);
			setLocalItem(STORAGE_KEYS.remember, '1');
		} else {
			removeLocalItem(STORAGE_KEYS.password);
			removeLocalItem(STORAGE_KEYS.remember);
		}
	} else {
		removeLocalItem(STORAGE_KEYS.password);
		removeLocalItem(STORAGE_KEYS.remember);
	}
};

export const clearRememberedPassword = () => {
	removeLocalItem(STORAGE_KEYS.password);
	removeLocalItem(STORAGE_KEYS.remember);
};
